import React from "react";
import { __ } from "services/Translator";

// Class 1 chrome goes through __(); the greeting and offline notice are Class 2
// server-authored copy, already localized by widget-config, so they are printed
// as they arrive and never wrapped.
export default function HomeView({ config, onStartConversation, onOpenList, onOpenKb }) {
  const strings = (config && config.strings && config.strings.ui) || {};
  const online = !!(config && config.business_hours && config.business_hours.online);
  const features = (config && config.features) || {};
  const chat = !!features.chat;
  const message = online ? strings.greeting : strings.offline;

  return (
    <div className="supHome">
      <div className={"supStatus " + (online ? "isOnline" : "isOffline")}>
        <span className="supStatusDot" aria-hidden="true" />
        {online ? __("We are online") : __("We are offline")}
      </div>

      {message && <p className="supGreeting">{message}</p>}

      <div className="supHomeActions">
        {chat && (
          <button type="button" className="supBtn supBtnPrimary" onClick={onStartConversation}>
            {__("Start a conversation")}
          </button>
        )}
        <button type="button" className="supBtn supBtnGhost" onClick={onOpenList}>
          {__("My conversations")}
        </button>
        {features.kb && (
          <button type="button" className="supBtn supBtnGhost" onClick={onOpenKb}>
            {__("Browse help")}
          </button>
        )}
      </div>
    </div>
  );
}
